<template>
  <div class="audit_div" :class="!visable?'audit-detail':''"
       v-if="this.processInfo.length > 0 || JSON.stringify(processInfo)!='{}'">
    <div :class="!visable?'':'item-title'">
      <div v-if='visable' class='circle'></div>
      <div :class="$route.path=='/mine/wallet/income'?'title1':'title'">{{
          $t('expense.beforeDetail.approvalProcess')
        }}
      </div>
    </div>
    <div :class="!visable?'expense-base-content_time1':'expense-base-content_time'">
      <pt-empty class='text' v-if="this.processInfo.length == 0 || JSON.stringify(processInfo)=='{}'">
      </pt-empty>
      <a-timeline :reverse='false'>
        <a-timeline-item v-for='(itemKey,index) in processInfoKeyArray ' :class="getLines(processInfo,index) "
                         :color="getActives(processInfo[itemKey])" :key=index :value='processInfo[itemKey]'>
          <div style='display: flex'>
            <div :class='getClass(processInfo[itemKey])' style='width: 140px;flex-shrink: 0;display: flex;justify-content: space-between'>
              <a-tooltip :title="processInfo[itemKey][0].name" placement="top">
                <span
                  style="width: 85px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{ processInfo[itemKey][0].name }}</span>
              </a-tooltip>
              <span v-if="processInfo[itemKey][0].countersignType == 2" class="allSign">{{ $t('key14quanqian') }}</span>
            </div>
            <div style='flex: auto'>
              <div style='display: flex;justify-content: space-between;margin-bottom: 5px;flex-direction: column'
                   v-for='(item1,index1) in processInfo[itemKey] '
                   :key=index1 :value='item1'>
                <div style='display: flex;flex-direction: row;'>
                  <div>
                    <div :class="item1.result != 2?'userName':'userName1'"
                         style="min-width: 150px;flex-shrink: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                      {{ $t('commission.reject.ApprovalPeople') }}: {{ item1.accountUser }}
                    </div>
                  </div>
                  <div style='flex: 1'>
                    <a-tooltip placement="bottomRight" arrow-point-at-center>
                    <span size="small" style='width: 51px;cursor: default'>
                       <pt-icon v-if='item1.result == 1' type='icon-wancheng'/>
                        <pt-icon v-else-if='item1.result == 0' type='icon-quxiao'/>
                      <span v-if='item1.result == 0' :class="item1.result != 2?'userName':'userName1'">
                        {{ $t('approval.processResult.0') }}
                      </span>
                       <span v-if='item1.result == 1' :class="item1.result != 2?'userName':'userName1'">
                        {{ $t('approval.processResult.1') }}
                      </span>
                       <span v-if='item1.result == 2' :class="item1.result != 2?'userName':'userName1'">
                        {{ $t('approval.processResult.2') }}
                      </span>
                      </span>
                    </a-tooltip>

                  </div>
                  <div :class="item1.result != 2?'userName':'userName1'"
                       style='display: flex;justify-content: end;min-width: 50px;flex-shrink: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap'>
                    <div :class="item1.result != 2?'userName':'userName1'"
                         style="min-width: 180px;flex-shrink: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                         v-if='item1.result != 2'>{{ $t('commission.reject.ApprovalTime') }}:
                      {{ $utils.format(item1.approveTime, 'YYYY-MM-DD HH:mm') }}
                    </div>

                  </div>
                </div>
                <div v-if='item1.reasons!= "~"' class='userName' style='max-width: 470px;overflow: hidden;'>
                  <a-tooltip placement="top" :title="item1.reasons">
                    <span style='overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'>
                       {{ $t('commission.reject.ApprovalReasons') }}:{{ item1.reasons }}
                    </span>
                  </a-tooltip>

                </div>
              </div>
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
  </div>
  <div :class="!visable?'audit-detail':''" v-else>
    <div :class="!visable?'':'item-title'">
      <div v-if='visable' class='circle'></div>
      <div class='title'>{{ $t('expense.beforeDetail.approvalProcess') }}</div>
    </div>
    <pt-empty class='text' v-if="this.processInfo.length == 0 || JSON.stringify(processInfo)=='{}'">
    </pt-empty>
  </div>
</template>

<script>
import Api from '@/api/mine/todo'

export default {
  name: 'auditDetail',
  props: {
    beforeInfo: {
      type: Object
    },
    type: 0,
    visable: true
  },
  data() {
    return {
      processInfo: [],
      processInfoKeyArray: []
    }
  },
  watch: {
    'beforeInfo.id'() {
      this.processInfo = [];
      this.processInfoKeyArray = [];
      this.initData()
    },
    'beforeInfo.createrId'() {
      this.processInfo = [];
      this.processInfoKeyArray = [];
      this.initData()
    }
  },
  mounted() {
    console.log('=======111=======')
    console.log('beforeInfo', this.beforeInfo)
    console.log('beforeInfo.type', this.type)
    console.log('beforeInfo.visable', this.visable)
    console.log('beforeInfo.createrId', this.beforeInfo.createrId)
    if (this.beforeInfo.id && this.getProcessCreaterId()) {
      this.initData()
    }
  },
  methods: {
    getProcessCreaterId() {
      return this.type == 1 ? this.beforeInfo.accountId : this.beforeInfo.createrId
    },

    getLines(item, index) {
      let ind = parseInt(index) + 1;
      let process = item[ind.toString()];
      let flag = false
      if (process && process.length > 0) {
        process.forEach(data => {
          if (data.countersignType == 2) {
            if (!data.active && data.result == 1) {
              flag = true
            } else {
              flag = false
            }
          } else {
            if (!data.active && data.result == 1) {
              flag = true
            }
          }
        })
      }
      return flag ? 'firstLine' : ''
    },


    getActives(item) {
      let flag = false
      item.forEach(data => {
        if (data.countersignType == 2) {
          if (!data.active && data.result == 1) {
            flag = true
          } else {
            flag = false
          }
        } else {
          if (!data.active && data.result == 1) {
            flag = true
          }
        }
      })
      return flag ? 'actives' : 'blue'
    },


    initData() {
      const processCreaterId = this.getProcessCreaterId()
      if (!this.beforeInfo || !this.beforeInfo.id || !processCreaterId) {
        return
      }
      if (this.type == undefined) {
        if (this.beforeInfo.beforeType == 1) {
          this.type = 6
        } else if (this.beforeInfo.beforeType == 2) {
          this.type = 7
        } else {
          this.type = 8
        }
      }

      Api.getProcessInfo(this.beforeInfo.id, this.type, processCreaterId).then(res => {
        if (res.code == 1) {
          this.processInfo = res.data ? res.data:[]
          if(res.data){
            this.processInfoKeyArray = this.sortObjectByKeys(res.data)
          }
          console.log('process',this.processInfo)
        }
      })
    },
    sortObjectByKeys(obj) {
      // 获取对象的所有键，并进行排序
      const sortedKeys = Object.keys(obj).sort();

      return sortedKeys;
    },
    getClass(data) {
      for (let i = 0; i < data.length; i++) {
        const datum = data[i]
        if (datum.result != 2) {
          return "userName";
        }
        return "userName1";
      }
    },
    toChinesNum(num) {
      let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] //changeNum[0] = "零"
      let unit = ['', '十', '百', '千', '万']
      num = parseInt(num)
      let getWan = (temp) => {
        let strArr = temp.toString().split('').reverse()
        let newNum = ''
        for (var i = 0; i < strArr.length; i++) {
          newNum = (i == 0 && strArr[i] == 0 ? '' : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum
        }
        return newNum
      }
      let overWan = Math.floor(num / 10000)
      let noWan = num % 10000
      if (noWan.toString().length < 4) noWan = '0' + noWan
      return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
    }
  }
}
</script>

<style scoped lang='less'>
@import "../../../../../core/diy";

.firstLine /deep/ .ant-timeline-item-tail {
  border-left: 2px solid #333333 !important;
}


.ant-timeline-item /deep/ .ant-timeline-item-content {
  top: -2px !important;
  margin: 0 0 0 30px !important;
  font-size: 12px !important;
}


.expense-base-content_time {
  height: auto;
  background-color: @block-color;
  padding: 34px 20px 0 20px;
  width: 100%;

  .userName {
    font-size: 12px;
    color: #333333;
    //color: #999999;
    letter-spacing: 0;
  }

  .userName1 {
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }
}

.expense-base-content_time1 {
  height: auto;
  background-color: @block-color;
  padding: 34px 0px 0 20px;
  width: 100%;

  .userName {
    font-family: PingFangTC-Semibold;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
  }

  .userName1 {
    font-family: PingFangTC-Semibold;
    font-size: 12px;

    color: #999999;
    letter-spacing: 0;
  }
}

.audit-detail {
  background: @block-color;
  margin: 10px;
  padding: 10px 16px;
}

.title {
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
}

.title1 {
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  width: 50px;
  margin-left: 10px;
}

.text {
  text-align: center;
  background: @block-color;
  margin-top: 1px;
  padding: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: auto;
}

.item-title {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: @text-color-3;
  margin: 30px 0 10px 0;

  .circle {
    background: @primary-color;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

.allSign {
  margin-left: 10px;
  font-size: 12px;
  color: #818181;
  background: #E8E8E8;
  border-radius: 1px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 5px;
  transform: scale(0.80);
  margin-top: 2px;
}
</style>
